/**
 * @file 申诉详情
 * @author wangzhuang
 */
import React from 'react';
import {connect} from 'react-redux';
import classnames from 'classnames';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Form, FormItem, Button, Checkbox, Toast, Upload} from '@baidu/spui';
import './index.less';
import {fetchGetDetail, fetchGetEdit} from '../../actions/appealAction';
import {location} from '../attestStep/location';
import {fetchSendCode} from '../../actions/attestAction';

const cascaderOptionData = [];

for (let attr in location[0]) {
    let children = [];
    for (let attr2 in location[`0,${attr}`]) {
        children.push({
            value: `${location[0][attr]},${location[`0,${attr}`][attr2]}`,
            name: location[`0,${attr}`][attr2]
        });
    }

    cascaderOptionData.push({
        value: location[0][attr],
        name: location[0][attr],
        children: children
    });
}

class InfoAppeal extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            formData: {
                radioType2: '2'
            },
            pageObj: {},
            status: 2,
            codeTime1: 60,
            codeTime2: 60,
            codeTimeGov: 60,
            codeTimeCom: 60,
            certOtherId: false,
            optionData: [
                {id: 1, label: '美食'},
                {id: 2, label: '酒店'},
                {id: 3, label: '购物'},
                {id: 4, label: '生活服务'},
                {id: 5, label: '快递物流'},
                {id: 6, label: '丽人'},
                {id: 7, label: '旅游景点'},
                {id: 8, label: '休闲娱乐'},
                {id: 9, label: '运动健身'},
                {id: 10, label: '教育培训'},
                {id: 11, label: '文化传媒'},
                {id: 12, label: '医疗'},
                {id: 13, label: '汽车服务'},
                {id: 14, label: '交通设施'},
                {id: 15, label: '金融'},
                {id: 16, label: '房地产'},
                {id: 17, label: '公司企业'},
                {id: 18, label: '政府机构'}
            ]
        };
    }

    componentDidMount() {
        this.getDetailFn();
    }

    getDetailFn = () => {
        let id = this.props.match.params.id;
        let create_time = this.props.match.params.type || 'edit';
        if (!id) {
            this.props.history.push('/');
        }

        this.props.fetchGetDetail({id: parseInt(id, 10), create_time}).then(data => {
            if (data.code === 200) {
                let obj = data.data.list;
                let jsonImg = {};
                let jsonFrom = {};

                if (obj.mode === 1) { // 企业
                    jsonImg = {
                        certOtherId: obj.cert_other_1,
                        companyQualifyId: obj.company_qualify_id,
                        companyQperatorId: obj.company_operator_id,
                    };
                    jsonFrom = {
                        nameCom: obj.name,
                        province: `${obj.company_province},${obj.company_city}`,
                        address: obj.company_addr,
                        industry: this.state.optionData.filter(item => {
                            return item.label === obj.industry;
                        })[0],
                        label: obj.label,
                        emailCom: obj.email,
                        otherReasonGov: obj.reason,
                    };
                }

                if (obj.mode === 2) { // 个人
                    jsonImg = {
                        certId: obj.cert_other_1,
                    };
                    jsonFrom = {
                        telType: obj.type === 2 ? 'phone' : 'tel',
                        label: obj.label,
                        email: obj.email,
                        reason: obj.reason,
                    };
                }

                if (obj.mode === 3) { // 政府
                    jsonImg = {
                        certGovId: obj.cert_other_1,
                        socialId: obj.social_id,
                    };
                    jsonFrom = {
                        label: obj.label,
                        nameGov: obj.name,
                        otherReasonGov: obj.reason,
                    };
                }

                this.setState({
                    pageObj: obj,
                    ...jsonImg,
                    formData: {
                        ...jsonFrom,
                        ...this.state.formData
                    }
                });
            } else {
                Toast.display({
                    type: 'error',
                    info: data.message,
                    delay: 3500
                });
            }
        });
    };


    formItemGetValue = ({name, value}) => {
        this.setState({
            formData: {
                ...this.state.formData,
                [name]: value
            }
        });
    };

    sendCodeFn = (val, type, verity) => {
        window.BCat_2055 && window.BCat_2055.miao();
        window['__abbaidu_2055_cb'] = responseData => {
            window['__abbaidu_2055_cb'] = null;
            let localData = JSON.parse(responseData);
            this.props.fetchSendCode({
                type: type === 'phone' ? 2 : 1,
                data: localData.data,
                'key_id': localData['key_id'],
                sign: localData.sign,
                verity: verity
            }).then(data => {
                if (data.code === 200) {
                    let timer = setInterval(() => {
                        let codeTime = this.state[`codeTime${val}`];
                        if (codeTime > 1) {
                            this.setState({
                                [`codeTime${val}`]: codeTime - 1
                            });
                        } else {
                            clearInterval(timer);
                            this.setState({
                                [`codeTime${val}`]: 60,
                                [`codeOff${val}`]: false
                            });
                        }
                    }, 1000);
                } else {
                    this.setState({
                        [`codeTime${val}`]: 60,
                        [`codeOff${val}`]: false
                    });
                    Toast.display({
                        type: 'error',
                        info: data.message,
                        delay: 3500
                    });
                }

            });
        };
    };
    handleCertId(cert) {
        let tempCert = cert;
        if (typeof tempCert ==='string') {
            tempCert = cert.split(',');
            tempCert = tempCert.map(v => +v);
            return tempCert;
        }

        if (typeof tempCert === 'number') {
            return [tempCert];
        }
    }
    submit = vlidate => {
        let id = this.props.match.params.id;
        let {pageObj, certGovId, socialId, certId, checkboxValue1, companyQualifyId,
            companyQperatorId, certOtherId} = this.state;
        let {
            nameGov, otherReasonGov, province, emailCom, captchaCom, address, captchaGov, industry, nameCom,
            telType, reason, captcha, captchaE, email, emailGov, label
        } = this.state.formData;
        let off = true;

        if (pageObj.mode === 2 && telType === 'tel') {
            if (!certId) {
                off = false;
                this.setState({
                    certError: '请上传证明材料'
                });
            } else {
                this.setState({
                    certError: ''
                });
            }
        }

        if (pageObj.mode === 3) {
            if (!socialId) {
                off = false;
                this.setState({
                    socialError: '社会信用代码证'
                });
            } else {
                this.setState({
                    socialError: ''
                });
            }

            if (!certGovId) {
                off = false;
                this.setState({
                    certGovError: '请上传证明材料'
                });
            } else {
                this.setState({
                    certGovError: ''
                });
            }
        }

        if (vlidate && off) {
            window.BCat_2055 && window.BCat_2055.miao();
            window['__abbaidu_2055_cb'] = responseData => {
                window['__abbaidu_2055_cb'] = null;
                let localData = JSON.parse(responseData);
                let json = {};
                let info = {
                    id: parseInt(id, 10),
                    data: localData.data,
                    'key_id': localData['key_id'],
                    sign: localData.sign,
                    mode: pageObj.mode
                };

                if (pageObj.mode === 1) { // 企业
                    json = {
                        ...info,
                        demand: 2,
                        name: nameCom,
                        // 'cert_id': [certGovId],
                        email: emailCom,
                        address: address,
                        code: captchaCom,
                        phone: pageObj.phone,
                        province: province.split(',')[0],
                        city: province.split(',')[1],
                        // 'social_id': [socialId],
                        'is_show': checkboxValue1 ? 1 : 0,
                        'company_qualify_id': this.handleCertId(companyQualifyId),
                        'company_operator_id': this.handleCertId(companyQperatorId),
                        'industry': industry.label,
                        'is_read': 1,
                        label: parseInt(label, 10),
                    };
                    if (certOtherId) {
                        json['cert_id'] = this.handleCertId(certOtherId);
                    }
                }

                if (pageObj.mode === 2) { // 个人
                    json = {
                        ...info,
                        label: 1,
                        reason: reason,
                        'is_show': checkboxValue1 ? 1 : 0,
                        'is_read': 1,
                        phone: pageObj.phone,
                        select: telType === 'phone' ? 2 : 1,
                    };


                    if (telType === 'phone') {
                        json['code'] = captcha;
                    } else {
                        json['email'] = email;
                        json['cert_id'] = this.handleCertId(certId);
                        json['code'] = captchaE;
                    }
                }


                if (pageObj.mode === 3) {
                    json = {
                        ...info,
                        demand: 2,
                        name: nameGov,
                        'cert_id': this.handleCertId(certGovId),
                        email: emailGov,
                        code: captchaGov,
                        phone: pageObj.phone,
                        'is_read': 1,
                        'social_id': this.handleCertId(socialId),
                        'reason': otherReasonGov,
                        'is_show': checkboxValue1 ? 1 : 0,
                        label: parseInt(label, 10),
                    };
                }

                this.props.fetchGetEdit(json).then(data => {
                    if (data.code === 200) {
                        this.getDetailFn();
                        this.props.history.push(`/info_appeal/${id}`);

                    } else {
                        Toast.display({
                            type: 'error',
                            info: data.message,
                            delay: 3500
                        });
                    }
                });
            };
        }
    };

    render() {
        let {id, type} = this.props.match.params;
        let {
            pageObj, formData, codeOff1, codeTime1, codeTime2, certId, certError, codeOff2, codeOffCom, codeTimeCom,
            companyQualifyId, companyQualifyError, companyQperatorId, companyQperatorError, certOtherId, certOtherError,
            socialId, socialError, certGovId, certGovError, codeOffGov, codeTimeGov, checkboxValue2, magnifyOff,
            magnifySrc
        } = this.state;
        let urlStr = '/api/v1/image/get?product_id=haoma&img_id=';
        let num = '1';
        let appealType = pageObj.mode;
        let imgType = '';
        let title = '';
        // let color = '';
        let text = '';
        let phone = pageObj.phone;
        let rePhone = /^1[3456789]\d{9}$/;
        let regEmail = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;

        if (pageObj.mode === 1) {
            appealType = '2';
        } else if (pageObj.mode === 2) {
            appealType = '1';
        }

        if (appealType) {
            appealType = appealType.toString();
        }
        // console.log(formData);

        const titleClass = classnames({
            'info-mod': true,
            'success': pageObj.person_status === 1,
            'error': pageObj.person_status === 2,
            'ing': pageObj.person_status === 0
        });

        switch (pageObj.person_status) {
            case 1:
                imgType = 'icon_success';
                title = '审核通过';
                // color = '#40C87F';
                text = '恭喜您，提交的资料和号码已完成审核，您可以通过百度搜索相关数据查看';
                break;

            case 2:
                imgType = 'icon_error';
                title = '审核未通过';
                // color = '#FF5F67';
                text = pageObj.person_reason;
                break;

            case 0:
                imgType = 'icon_toast';
                title = '审核中';
                // color = '#FFF';
                text = <div>
                    <div>您当前提交的资质和号码，已经到审核阶段，工作人员正在快马加鞭的进行审核</div>
                    <div>我们会在5-7个工作日内完成审核，请您耐心等待</div>
                </div>;
                break;
        }

        const btnProps = {
            label: '修改信息',
            value: 'HAHAHA',
            styleType: 'modal',
            disabled: pageObj.person_status === 0,
            onClick: () => {
                this.props.history.push(`/info_appeal/${id}/edit`);
            }
        };

        return (
            <div className={'InfoAttest InfoAppeal appealStep attest'}>
                {!this.isEmptyobj(pageObj)
                    ? <div>
                        <div className={titleClass}>
                            <div className={'top'}/>
                            <div className={'con'}>
                                <div className={'left'}>
                                    <div className={'title'}>
                                        <img src={require(`../../asset/img/infoAttest/${imgType}.png`)} alt=""/>
                                        <div>{title}</div>
                                    </div>
                                    <div className={'text'}>
                                        {text}
                                    </div>
                                </div>
                                <div className={'right'}>
                                    提交时间：{pageObj.create_time ? pageObj.create_time : '-'}<br/>
                                    更新时间：{pageObj.update_time ? pageObj.update_time : '-'}<br/>
                                </div>
                            </div>
                        </div>

                        {
                            type === 'edit'
                                ? <div className={'info-from'}>
                                    <div className={'mod2-from'}>
                                        <Form submit={this.submit} ref={el => (this.myFrom = el)}>
                                            <div className={'from-mod'}>
                                                <div className={'from-mod-left'}>
                                                    <i className={'star'}>*</i><span>申诉号码</span>
                                                </div>
                                                <div className={'from-mod-right line40'}>
                                                    {phone}
                                                </div>
                                            </div>

                                            <div className={'from-mod'}>
                                                <div className={'from-mod-left'}>
                                                    <i className={'star'}>*</i><span>申诉类型</span>
                                                </div>
                                                <div className={'from-mod-right line40'}>
                                                    {{
                                                        '1': '个人号码申诉',
                                                        '2': '企业号码申诉',
                                                        '3': '政府号码申诉'
                                                    }[appealType]}
                                                </div>
                                            </div>

                                            {appealType === '1' && num !== '2'
                                                ? <div>
                                                    <FormItem
                                                        className={'line20'}
                                                        theme={'blue'}
                                                        label={<span><i className={'star'}>*</i>号码类型</span>}
                                                        type="radio"
                                                        name={'telType'}
                                                        disabled={true}
                                                        value={formData.telType}
                                                        optionData={[
                                                            {name: 'phone', value: '手机号码'},
                                                            {name: 'tel', value: '座机号码'}
                                                        ]}
                                                        getValue={this.formItemGetValue}
                                                    />

                                                    <FormItem
                                                        className={'line20'}
                                                        theme={'blue'}
                                                        label={<span><i className={'star'}>*</i>申诉理由</span>}
                                                        type="radio"
                                                        name={'reason'}
                                                        noWarning
                                                        value={formData.label}
                                                        optionData={[
                                                            {name: '1', value: '号码被错误标记/占用'},
                                                        ]}
                                                        getValue={this.formItemGetValue}
                                                    />

                                                    <FormItem
                                                        type="textarea"
                                                        name={'reason'}
                                                        width={'400px'}
                                                        className={'textareaPerson'}
                                                        spellCheck={false}
                                                        value={formData.reason}
                                                        resize={false}
                                                        hidden={false}
                                                        label={'其他理由'}
                                                        placeHolder={'请填写申诉理由'}
                                                        getValue={this.formItemGetValue}
                                                    />


                                                    {formData.telType === 'phone'
                                                        ? <div>
                                                            <div>
                                                                <FormItem
                                                                    type="input"
                                                                    value={formData.captcha}
                                                                    spellCheck={false}
                                                                    name={'captcha'}
                                                                    horizontal={true}
                                                                    width={'120px'}
                                                                    label={
                                                                        <span><i className={'star'}>*</i>手机验证码</span>
                                                                    }
                                                                    placeHolder={'请输入验证码'}
                                                                    tips={!codeOff1
                                                                        ? <span
                                                                            className={rePhone.test(phone)
                                                                                ? 'link'
                                                                                : 'disable'}
                                                                            onClick={() => {
                                                                                if (rePhone.test(phone)) {
                                                                                    this.setState({
                                                                                        codeOff1: true
                                                                                    }, () => {
                                                                                        this.sendCodeFn(
                                                                                            1,
                                                                                            'phone',
                                                                                            phone
                                                                                        );
                                                                                    });
                                                                                }
                                                                            }}
                                                                        >
                                                                            获取验证码
                                                                        </span>
                                                                        : <span className={'disable'}>
                                                                            {codeTime1}s后重新发送
                                                                        </span>
                                                                    }
                                                                    rules={
                                                                        [{
                                                                            validate(s) {
                                                                                let v = s.replace(/(^\s*)|(\s*$)/g, '');
                                                                                return v.length === 0;
                                                                            },
                                                                            message: '此项不能为空！'
                                                                        }
                                                                        ]
                                                                    }
                                                                    getValue={this.formItemGetValue}
                                                                />
                                                            </div>
                                                        </div>
                                                        : null
                                                    }

                                                    {formData.telType === 'tel'
                                                        ? <div>
                                                            <div className={'from-mod pb24'}>
                                                                <div className={'from-mod-left'}>
                                                                    <i className={'star'}>*</i><span>证明材料</span>
                                                                </div>
                                                                <div className={'from-mod-right pr'}>
                                                                    <Upload
                                                                        fileId={'feui-certId'}
                                                                        uploadType={'image-upload'}
                                                                        noWarning={true}
                                                                        name={'image'}
                                                                        width={'96px'}
                                                                        height={'96px'}
                                                                        onHandleChange={data => {
                                                                            let file = data.value;

                                                                            if (file.type.substr(-3) !== 'png'
                                                                                && data.value.type.substr(-4)
                                                                                !== 'jpeg') {
                                                                                this.setState({
                                                                                    certError: '图片格式不正确'
                                                                                });
                                                                                return false;
                                                                            }

                                                                            if (file.size > (1024 * 1024)) { // 1M
                                                                                this.setState({
                                                                                    certError: '图片大小不符合要求'
                                                                                });
                                                                                return false;
                                                                            }

                                                                            file.formDatas.append(
                                                                                'product_id',
                                                                                'haoma'
                                                                            );
                                                                            file.formDatas.append(
                                                                                'is_spot',
                                                                                'NO'
                                                                            );

                                                                            let myInit = {
                                                                                method: 'POST',
                                                                                credentials: 'include',
                                                                                body: file.formDatas
                                                                            };

                                                                            fetch('/api/v1/image', myInit)
                                                                                .then(response => response.json())
                                                                                .then(response => {
                                                                                    if (response.code === 200) {
                                                                                        this.setState({
                                                                                            certId: response.data.id
                                                                                        });
                                                                                    } else {
                                                                                        Toast.display({
                                                                                            type: 'error',
                                                                                            info: response.message,
                                                                                            delay: 3500
                                                                                        });

                                                                                    }
                                                                                });
                                                                        }}
                                                                    />
                                                                    {certId
                                                                        ? <div
                                                                            className={'load-mod'}
                                                                            style={{
                                                                                backgroundImage: `url(${
                                                                                    urlStr + certId}
                                                                                )`
                                                                            }}
                                                                            onClick={() => {
                                                                                this.setState({
                                                                                    magnifySrc: `${urlStr + certId}`,
                                                                                    magnifyOff: true,
                                                                                });
                                                                            }}
                                                                        >
                                                                            <div
                                                                                className={'close'}
                                                                                onClick={e => {
                                                                                    this.setState({
                                                                                        certId: false
                                                                                    });
                                                                                    e.stopPropagation();
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        : null
                                                                    }
                                                                    {
                                                                        certError
                                                                            ? <div className="spui2-form-warning">
                                                                                <i className="spui2-input-error"></i>
                                                                                <span>{certError}</span>
                                                                            </div>
                                                                            : null
                                                                    }
                                                                    <div
                                                                        className={'shangbiao'}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                magnifySrc: require('../../asset/img'
                                                                                    + '/appeal/geren_1.jpg'),
                                                                                magnifyOff: true,
                                                                            });
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={require('../../asset/img'
                                                                                + '/appeal/geren_1.jpg')}
                                                                            alt=""/>
                                                                        <span>上传样例</span>
                                                                        <i/>
                                                                    </div>
                                                                    <div
                                                                        className={'shangbiao'}
                                                                        style={{left: '264px'}}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                magnifySrc: require('../../asset/'
                                                                                    + 'img/appeal/geren_2.png'),
                                                                                magnifyOff: true,
                                                                            });
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={require('../../asset/'
                                                                                + 'img/appeal/geren_2.png')}
                                                                            alt=""/>
                                                                        <span>上传样例</span>
                                                                        <i/>
                                                                    </div>
                                                                    <div
                                                                        className={'shangbiao'}
                                                                        style={{left: '488px'}}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                magnifySrc: require('../../asset/'
                                                                                    + 'img/appeal/geren_3.jpg'),
                                                                                magnifyOff: true,
                                                                            });
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={require('../../asset/img'
                                                                                + '/appeal/geren_3.jpg')}
                                                                            alt=""/>
                                                                        <span>上传样例</span>
                                                                        <i/>
                                                                    </div>
                                                                    <div
                                                                        className={'icon-text'}
                                                                        style={{width: '370px', left: '567px'}}
                                                                    >
                                                                        <div>
                                                                            <span>
                                                                                {'申诉号码的开户证明，缴费证明，'
                                                                                + '网页截图等有效证明。任选其一'}
                                                                            </span>
                                                                            <br/>
                                                                            <span>图片支持jpg或png格式，大小不超过1M</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <FormItem
                                                                type="input"
                                                                value={formData.email}
                                                                spellCheck={false}
                                                                name={'email'}
                                                                horizontal={true}
                                                                label={<span><i className={'star'}>*</i>联系邮箱</span>}
                                                                placeHolder={'请输入正确的邮箱地址用来接收审核结果等'}
                                                                rules={
                                                                    [
                                                                        {
                                                                            validate(s) {
                                                                                let v = s.replace(/(^\s*)|(\s*$)/g, '');
                                                                                return v.length === 0;
                                                                            },
                                                                            message: '此项不能为空！'
                                                                        },
                                                                        {
                                                                            validate(value) {
                                                                                return !regEmail.test(value);
                                                                            },
                                                                            message: '联系邮箱格式不正确！'
                                                                        }
                                                                    ]
                                                                }
                                                                getValue={this.formItemGetValue}
                                                            />
                                                            <div>
                                                                <FormItem
                                                                    type="input"
                                                                    value={formData.captchaE}
                                                                    spellCheck={false}
                                                                    name={'captchaE'}
                                                                    horizontal={true}
                                                                    width={'120px'}
                                                                    label={
                                                                        <span><i className={'star'}>*</i>邮箱验证码</span>
                                                                    }
                                                                    placeHolder={'请输入验证码'}
                                                                    tips={!codeOff2
                                                                        ? <span
                                                                            className={regEmail.test(formData.email)
                                                                                ? 'link'
                                                                                : 'disable'
                                                                            }
                                                                            onClick={() => {
                                                                                if (regEmail.test(formData.email)) {
                                                                                    this.setState({
                                                                                        codeOff2: true
                                                                                    }, () => {
                                                                                        this.sendCodeFn(
                                                                                            2,
                                                                                            'email',
                                                                                            formData.email
                                                                                        );
                                                                                    });
                                                                                }
                                                                            }}
                                                                        >
                                                                            获取验证码
                                                                        </span>
                                                                        : <span className={'disable'}>
                                                                            {codeTime2}s后重新发送
                                                                        </span>
                                                                    }
                                                                    rules={
                                                                        [{
                                                                            validate(s) {
                                                                                let v = s.replace(/(^\s*)|(\s*$)/g, '');
                                                                                return v.length === 0;
                                                                            },
                                                                            message: '此项不能为空！'
                                                                        }]
                                                                    }
                                                                    getValue={this.formItemGetValue}
                                                                />
                                                            </div>
                                                        </div>
                                                        : null
                                                    }
                                                </div>
                                                : null
                                            }

                                            {
                                                appealType === '2'
                                                    ? <FormItem
                                                        className={'line20 mt9'}
                                                        theme={'blue'}
                                                        label={<span><i className={'star'}>*</i>申诉理由</span>}
                                                        type="radio"
                                                        name={'label'}
                                                        value={formData.label}
                                                        optionData={[
                                                            {name: '1', value: '号码被错误标记/占用'},
                                                            {name: '2', value: '不希望显示企业号码'},
                                                            {name: '3', value: '企业与号码信息有误'}
                                                        ]}
                                                        getValue={this.formItemGetValue}
                                                    />
                                                    : null
                                            }
                                            {
                                                appealType === '3'
                                                    ? <FormItem
                                                        className={'line20 mt9'}
                                                        theme={'blue'}
                                                        label={<span><i className={'star'}>*</i>申诉理由</span>}
                                                        type="radio"
                                                        name={'label'}
                                                        value={formData.label}
                                                        optionData={[
                                                            {name: '1', value: '号码被错误标记/占用'},
                                                            {name: '2', value: '不希望显示政府号码'},
                                                            {name: '3', value: '政府与号码信息有误'},
                                                        ]}
                                                        getValue={this.formItemGetValue}
                                                    />
                                                    : null
                                            }

                                            {(appealType === '2' && formData.radioType2 === '2') || num === '2'
                                                ? <div>
                                                    <div className={'from-mod mt20 pb24'}>
                                                        <div className={'from-mod-left'}>
                                                            <i className={'star'}>*</i><span>企业合法资质</span>
                                                        </div>
                                                        <div className={'from-mod-right pr'}>
                                                            <Upload
                                                                fileId={'feui-companyQualifyId'}
                                                                uploadType={'image-upload'}
                                                                noWarning={true}
                                                                name={'image'}
                                                                width={'96px'}
                                                                height={'96px'}
                                                                onHandleChange={data => {
                                                                    let file = data.value;
                                                                    if (file.type.substr(-3) !== 'png'
                                                                        && data.value.type.substr(-4) !== 'jpeg') {
                                                                        this.setState({
                                                                            companyQualifyError: '图片格式不正确'
                                                                        });
                                                                        return false;
                                                                    }

                                                                    this.setState({
                                                                        logoError: ''
                                                                    });

                                                                    file.formDatas.append('product_id', 'haoma');
                                                                    file.formDatas.append('is_spot', 'YES');

                                                                    let myInit = {
                                                                        method: 'POST',
                                                                        credentials: 'include',
                                                                        body: file.formDatas
                                                                    };

                                                                    fetch('/api/v1/image', myInit)
                                                                        .then(response => response.json())
                                                                        .then(response => {
                                                                            if (response.code === 200) {
                                                                                formData.nameCom = response.data.name;
                                                                                this.setState({
                                                                                    formData: formData,
                                                                                    companyQualifyId: response.data.id
                                                                                });
                                                                            } else {
                                                                                Toast.display({
                                                                                    type: 'error',
                                                                                    info: response.message,
                                                                                    delay: 3500
                                                                                });

                                                                            }
                                                                        });
                                                                }}
                                                            />
                                                            {companyQualifyId
                                                                ? <div
                                                                    className={'load-mod'}
                                                                    style={{
                                                                        backgroundImage: `url(${
                                                                            urlStr + companyQualifyId
                                                                        })`
                                                                    }}
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            magnifySrc: `${
                                                                                urlStr + companyQualifyId
                                                                            }`,
                                                                            magnifyOff: true,
                                                                        });
                                                                    }}
                                                                >
                                                                    <div
                                                                        className={'close'}
                                                                        onClick={e => {
                                                                            this.setState({
                                                                                companyQualifyId: false
                                                                            });
                                                                            e.stopPropagation();
                                                                        }}
                                                                    />
                                                                </div>
                                                                : null
                                                            }
                                                            {
                                                                companyQualifyError
                                                                    ? <div className="spui2-form-warning">
                                                                        <i className="spui2-input-error"></i>
                                                                        <span>{companyQualifyError}</span>
                                                                    </div>
                                                                    : null
                                                            }
                                                            <div
                                                                className={'shangbiao'}
                                                                onClick={() => {
                                                                    this.setState({
                                                                        magnifySrc: require('../../asset/'
                                                                            + 'img/attest/zizhi.jpg'),
                                                                        magnifyOff: true,
                                                                    });
                                                                }}
                                                            >
                                                                <img
                                                                    src={require('../../asset/img'
                                                                        + '/attest/zizhi.jpg')}
                                                                    alt=""/>
                                                                <span>上传样例</span>
                                                                <i/>
                                                            </div>
                                                            <div
                                                                className={'icon-text'}
                                                                style={{width: '371px', left: '183px'}}
                                                            >
                                                                <div>
                                                                    <span>
                                                                        最新年检的企业营业执照，个体工商户执照，组织机构代码证，税务证书（三合一）
                                                                    </span><br/>
                                                                    <span>
                                                                        图片支持jpg或png格式
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <FormItem
                                                        type="input"
                                                        value={formData.nameCom}
                                                        spellCheck={false}
                                                        name={'nameCom'}
                                                        horizontal={true}
                                                        label={<span><i className={'star'}>*</i>企业名称</span>}
                                                        placeHolder={'系统自动识别，和企业资质保持一致'}
                                                        rules={
                                                            [
                                                                {
                                                                    validate(value) {
                                                                        let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                                        return v.length === 0;
                                                                    },
                                                                    message: '此项不能为空！'
                                                                }
                                                            ]
                                                        }
                                                        getValue={this.formItemGetValue}
                                                    />

                                                    <FormItem
                                                        type={'cascader'}
                                                        label={<span><i className={'star'}>*</i>企业地址</span>}
                                                        width={400}
                                                        name={'province'}
                                                        optionData={cascaderOptionData}
                                                        placeHolder={'和企业资质保持一致'}
                                                        value={formData.province}
                                                        dropdownItemWidth={133.999}
                                                        getValue={this.formItemGetValue}
                                                        rules={
                                                            [
                                                                {
                                                                    validate(value) {
                                                                        return value.length === 0;
                                                                    },
                                                                    message: '此项不能为空！'
                                                                }
                                                            ]
                                                        }
                                                    />

                                                    <FormItem
                                                        type="textarea"
                                                        name={'address'}
                                                        width={'400px'}
                                                        spellCheck={false}
                                                        value={formData.address}
                                                        resize={false}
                                                        hidden={false}
                                                        label={' '}
                                                        countWay="character"
                                                        countComplete={true}
                                                        placeHolder={'和企业资质保持一致\n'
                                                        + '请确保为实际办公地址'}
                                                        rules={
                                                            [
                                                                {
                                                                    validate(value) {
                                                                        let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                                        return v.length === 0;
                                                                    },
                                                                    message: '此项不能为空！'
                                                                }
                                                            ]
                                                        }
                                                        getValue={this.formItemGetValue}
                                                    />

                                                    <FormItem
                                                        value={formData.industry}
                                                        type="select"
                                                        width={400}
                                                        name="industry"
                                                        label={<span><i className={'star'}>*</i>行业类型</span>}
                                                        placeHolder={'请选择您所属的行业类型'}
                                                        cancelIcon
                                                        optionData={[
                                                            {label: '美食'},
                                                            {label: '酒店'},
                                                            {label: '购物'},
                                                            {label: '生活服务'},
                                                            {label: '快递物流'},
                                                            {label: '丽人'},
                                                            {label: '旅游景点'},
                                                            {label: '休闲娱乐'},
                                                            {label: '运动健身'},
                                                            {label: '教育培训'},
                                                            {label: '文化传媒'},
                                                            {label: '医疗'},
                                                            {label: '汽车服务'},
                                                            {label: '交通设施'},
                                                            {label: '金融'},
                                                            {label: '房地产'},
                                                            {label: '公司企业'},
                                                            {label: '政府机构'}
                                                        ]}
                                                        getValue={this.formItemGetValue}
                                                        rules={
                                                            [
                                                                {
                                                                    validate(value) {
                                                                        return !value || (!value.label);
                                                                    },
                                                                    message: '此项不能为空！'
                                                                }
                                                            ]
                                                        }
                                                    />

                                                    <div className={'from-mod mt20 pb24'}>
                                                        <div className={'from-mod-left'}>
                                                            <i className={'star'}>*</i><span>运营商证明</span>
                                                        </div>
                                                        <div className={'from-mod-right pr'}>
                                                            <Upload
                                                                fileId={'feui-companyQperatorId'}
                                                                uploadType={'image-upload'}
                                                                noWarning={true}
                                                                name={'image'}
                                                                width={'96px'}
                                                                height={'96px'}
                                                                onHandleChange={data => {
                                                                    let file = data.value;
                                                                    if (file.type.substr(-3) !== 'png'
                                                                        && data.value.type.substr(-4) !== 'jpeg') {
                                                                        this.setState({
                                                                            companyQperatorError: '图片格式不正确'
                                                                        });
                                                                        return false;
                                                                    }

                                                                    if (file.size > (1024 * 1024)) { // 1M
                                                                        this.setState({
                                                                            companyQperatorError: '图片大小不符合要求'
                                                                        });
                                                                        return false;
                                                                    }

                                                                    this.setState({
                                                                        companyQperatorError: ''
                                                                    });

                                                                    file.formDatas.append('product_id', 'haoma');
                                                                    file.formDatas.append('is_spot', 'NO');

                                                                    let myInit = {
                                                                        method: 'POST',
                                                                        credentials: 'include',
                                                                        body: file.formDatas
                                                                    };

                                                                    fetch('/api/v1/image', myInit)
                                                                        .then(response => response.json())
                                                                        .then(response => {
                                                                            if (response.code === 200) {
                                                                                this.setState({
                                                                                    companyQperatorId: response.data.id
                                                                                });
                                                                            } else {
                                                                                Toast.display({
                                                                                    type: 'error',
                                                                                    info: response.message,
                                                                                    delay: 3500
                                                                                });

                                                                            }
                                                                        });
                                                                }}
                                                            />
                                                            {companyQperatorId
                                                                ? <div
                                                                    className={'load-mod'}
                                                                    style={{
                                                                        backgroundImage: `url(${
                                                                            urlStr + companyQperatorId
                                                                        })`
                                                                    }}
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            magnifySrc: `${
                                                                                urlStr + companyQperatorId
                                                                            }`,
                                                                            magnifyOff: true,
                                                                        });
                                                                    }}
                                                                >
                                                                    <div
                                                                        className={'close'}
                                                                        onClick={e => {
                                                                            this.setState({
                                                                                companyQperatorId: false
                                                                            });
                                                                            e.stopPropagation();
                                                                        }}
                                                                    />
                                                                </div>
                                                                : null
                                                            }
                                                            {
                                                                companyQperatorError
                                                                    ? <div className="spui2-form-warning">
                                                                        <i className="spui2-input-error"></i>
                                                                        <span>{companyQperatorError}</span>
                                                                    </div>
                                                                    : null
                                                            }
                                                            <div
                                                                className={'shangbiao'}
                                                                onClick={() => {
                                                                    this.setState({
                                                                        magnifySrc: require('../../asset/img'
                                                                            + '/attest/yunying.png'),
                                                                        magnifyOff: true,
                                                                    });
                                                                }}
                                                            >
                                                                <img
                                                                    src={require('../../asset/img/'
                                                                        + 'attest/yunying.png')}
                                                                    alt=""/>
                                                                <span>上传样例</span>
                                                                <i/>
                                                            </div>
                                                            <div
                                                                className={'icon-text'}
                                                                style={{width: '304px', left: '264px'}}>
                                                                认证号码的开户证明，缴费证明等有效证明，选其一即可
                                                                图片支持jpg或png格式，大小不超过1M
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className={'form-mod2'}>
                                                        <div>
                                                            <div className={'from-mod mt20 pb24'}>
                                                                <div className={'from-mod-left'}>
                                                                    其他证明
                                                                </div>
                                                                <div className={'from-mod-right pr'}>
                                                                    <Upload
                                                                        fileId={'feui-certOtherId'}
                                                                        uploadType={'image-upload'}
                                                                        noWarning={true}
                                                                        name={'image'}
                                                                        width={'96px'}
                                                                        height={'96px'}
                                                                        onHandleChange={data => {
                                                                            let file = data.value;
                                                                            if (file.type.substr(-3) !== 'png'
                                                                                && data.value.type.substr(-4)
                                                                                !== 'jpeg') {
                                                                                this.setState({
                                                                                    certOtherError: '图片格式不正确'
                                                                                });
                                                                                return false;
                                                                            }

                                                                            if (file.size > (1024 * 1024)) { // 1M
                                                                                this.setState({
                                                                                    certOtherError: '图片大小不符合要求'
                                                                                });
                                                                                return false;
                                                                            }

                                                                            file.formDatas.append(
                                                                                'product_id',
                                                                                'haoma'
                                                                            );
                                                                            file.formDatas.append(
                                                                                'is_spot',
                                                                                'NO'
                                                                            );

                                                                            let myInit = {
                                                                                method: 'POST',
                                                                                credentials: 'include',
                                                                                body: file.formDatas
                                                                            };

                                                                            fetch('/api/v1/image', myInit)
                                                                                .then(response => response.json())
                                                                                .then(response => {
                                                                                    if (response.code === 200) {
                                                                                        this.setState({
                                                                                            certOtherId: response
                                                                                                .data.id
                                                                                        });
                                                                                    } else {
                                                                                        Toast.display({
                                                                                            type: 'error',
                                                                                            info: response.message,
                                                                                            delay: 3500
                                                                                        });

                                                                                    }
                                                                                });
                                                                        }}
                                                                    />
                                                                    {certOtherId
                                                                        ? <div
                                                                            className={'load-mod'}
                                                                            style={{
                                                                                backgroundImage: `url(${
                                                                                    urlStr + certOtherId
                                                                                })`
                                                                            }}
                                                                            onClick={() => {
                                                                                this.setState({
                                                                                    magnifySrc: `${
                                                                                        urlStr + certOtherId
                                                                                    }`,
                                                                                    magnifyOff: true,
                                                                                });
                                                                            }}
                                                                        >
                                                                            <div
                                                                                className={'close'}
                                                                                onClick={e => {
                                                                                    this.setState({
                                                                                        certOtherId: false
                                                                                    });
                                                                                    e.stopPropagation();
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        : null
                                                                    }
                                                                    {certOtherError
                                                                        ? <div className="spui2-form-warning">
                                                                            <i className="spui2-input-error"></i>
                                                                            <span>{certOtherError}</span>
                                                                        </div>
                                                                        : null
                                                                    }
                                                                    <div
                                                                        className={'shangbiao'}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                magnifySrc: require('../../asset/'
                                                                                    + 'img/attest/400ruwang.jpg'),
                                                                                magnifyOff: true
                                                                            });
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={require('../../asset/img'
                                                                                + '/attest/400ruwang.jpg')}
                                                                            alt=""/>
                                                                        <span>上传样例</span>
                                                                        <i/>
                                                                    </div>
                                                                    <div
                                                                        className={'shangbiao'}
                                                                        style={{left: '250px'}}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                magnifySrc: require('../../asset/'
                                                                                    + 'img/attest/ruwang.jpg'),
                                                                                magnifyOff: true,
                                                                            });
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={require(
                                                                                '../../asset/img/attest/ruwang.jpg'
                                                                            )}
                                                                            alt=""/>
                                                                        <span>上传样例</span>
                                                                        <i/>
                                                                    </div>
                                                                    <div
                                                                        className={'icon-text'}
                                                                        style={{width: '300px', left: '325px'}}
                                                                    >
                                                                        多个号码需认证时，可证明号码与认证企业有关联的材料
                                                                        图片支持jpg或png格式，大小不超过1M
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <FormItem
                                                                type="input"
                                                                value={formData.emailCom}
                                                                spellCheck={false}
                                                                name={'emailCom'}
                                                                horizontal={true}
                                                                label={<span><i className={'star'}>*</i>联系邮箱</span>}
                                                                placeHolder={'请输入正确的邮箱地址用来接收到期缴费及系统通知等'}
                                                                rules={
                                                                    [{
                                                                        validate(s) {
                                                                            let v = s.replace(/(^\s*)|(\s*$)/g, '');
                                                                            return v.length === 0;
                                                                        },
                                                                        message: '此项不能为空！'
                                                                    }, {
                                                                        validate(value) {
                                                                            return !regEmail.test(value);
                                                                        },
                                                                        message: '联系邮箱格式不正确！'
                                                                    }]
                                                                }
                                                                getValue={this.formItemGetValue}
                                                            />

                                                            <FormItem
                                                                type="input"
                                                                value={formData.captchaCom}
                                                                spellCheck={false}
                                                                name={'captchaCom'}
                                                                horizontal={true}
                                                                width={'120px'}
                                                                label={
                                                                    <span><i className={'star'}>*</i>邮箱验证码</span>
                                                                }
                                                                placeHolder={'请输入验证码'}
                                                                tips={!codeOffCom
                                                                    ? <span
                                                                        className={regEmail.test(
                                                                            formData.emailCom) ? 'link' : 'disable'
                                                                        }
                                                                        onClick={() => {
                                                                            if (regEmail.test(formData.emailCom)) {
                                                                                this.setState({
                                                                                    codeOffCom: true
                                                                                }, () => {
                                                                                    this.sendCodeFn(
                                                                                        'Com',
                                                                                        'email',
                                                                                        formData.emailCom
                                                                                    );
                                                                                });
                                                                            }
                                                                        }}
                                                                    >
                                                                        获取验证码
                                                                    </span>
                                                                    : <span className={'disable'}>
                                                                        {codeTimeCom}s后重新发送
                                                                    </span>
                                                                }
                                                                rules={
                                                                    [{
                                                                        validate(s) {
                                                                            let v = s.replace(/(^\s*)|(\s*$)/g, '');
                                                                            return v.length === 0;
                                                                        },
                                                                        message: '此项不能为空！'
                                                                    }]
                                                                }
                                                                getValue={this.formItemGetValue}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                : null
                                            }

                                            {appealType === '3'
                                                ? <div>
                                                    <div className={'from-mod pb24'}>
                                                        <div className={'from-mod-left'}>
                                                            <i className={'star'}>*</i>
                                                            <span>社会信用代码证</span>
                                                        </div>
                                                        <div className={'from-mod-right pr'}>
                                                            <Upload
                                                                fileId={'feui-socialId'}
                                                                uploadType={'image-upload'}
                                                                noWarning={true}
                                                                name={'image'}
                                                                width={'96px'}
                                                                height={'96px'}
                                                                onHandleChange={data => {
                                                                    let file = data.value;
                                                                    if (file.type.substr(-3) !== 'png'
                                                                        && data.value.type.substr(-4) !== 'jpeg') {
                                                                        this.setState({
                                                                            socialError: '图片格式不正确'
                                                                        });
                                                                        return false;
                                                                    }

                                                                    this.setState({
                                                                        socialError: ''
                                                                    });

                                                                    file.formDatas.append('product_id', 'haoma');
                                                                    file.formDatas.append('is_spot', 'NO');

                                                                    let myInit = {
                                                                        method: 'POST',
                                                                        credentials: 'include',
                                                                        body: file.formDatas
                                                                    };

                                                                    fetch('/api/v1/image', myInit)
                                                                        .then(response => response.json())
                                                                        .then(response => {
                                                                            if (response.code === 200) {
                                                                                this.setState({
                                                                                    socialId: response.data.id
                                                                                });
                                                                            } else {
                                                                                Toast.display({
                                                                                    type: 'error',
                                                                                    info: response.message,
                                                                                    delay: 3500
                                                                                });

                                                                            }
                                                                        });
                                                                }}
                                                            />
                                                            {socialId
                                                                ? <div
                                                                    className={'load-mod'}
                                                                    style={{
                                                                        backgroundImage: `url(${urlStr + socialId})`
                                                                    }}
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            magnifySrc: `${urlStr + socialId}`,
                                                                            magnifyOff: true,
                                                                        });
                                                                    }}
                                                                >
                                                                    <div
                                                                        className={'close'}
                                                                        onClick={e => {
                                                                            this.setState({
                                                                                socialId: false
                                                                            });
                                                                            e.stopPropagation();
                                                                        }}
                                                                    />
                                                                </div>
                                                                : null
                                                            }
                                                            {
                                                                socialError
                                                                    ? <div className="spui2-form-warning">
                                                                        <i className="spui2-input-error"></i>
                                                                        <span>{socialError}</span>
                                                                    </div>
                                                                    : null
                                                            }
                                                            <div
                                                                className={'shangbiao'}
                                                                onClick={() => {
                                                                    this.setState({
                                                                        magnifySrc: require(
                                                                            '../../asset/img/appeal/code_1.jpg'
                                                                        ),
                                                                        magnifyOff: true,
                                                                    });
                                                                }}
                                                            >
                                                                <img
                                                                    src={require(
                                                                        '../../asset/img/appeal/code_1.jpg'
                                                                    )}
                                                                    alt=""/>
                                                                <span>上传样例</span>
                                                                <i/>
                                                            </div>
                                                            <div
                                                                className={'shangbiao'}
                                                                style={{left: '257px'}}
                                                                onClick={() => {
                                                                    this.setState({
                                                                        magnifySrc: require(
                                                                            '../../asset/img/appeal/code_2.jpg'
                                                                        ),
                                                                        magnifyOff: true,
                                                                    });
                                                                }}
                                                            >
                                                                <img
                                                                    src={require(
                                                                        '../../asset/img/appeal/code_2.jpg'
                                                                    )}
                                                                    alt=""/>
                                                                <span>上传样例</span>
                                                                <i/>
                                                            </div>
                                                            <div
                                                                className={'icon-text'}
                                                                style={{width: '370px', left: '402px'}}
                                                            >
                                                                统一社会信用代码证，图片支持ipg或png格式
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <FormItem
                                                        type="input"
                                                        value={formData.nameGov}
                                                        spellCheck={false}
                                                        name={'nameGov'}
                                                        horizontal={true}
                                                        label={<span><i className={'star'}>*</i>政府名称</span>}
                                                        placeHolder={'请输入政府名称'}
                                                        rules={
                                                            [
                                                                {
                                                                    validate(value) {
                                                                        let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                                        return v.length === 0;
                                                                    },
                                                                    message: '此项不能为空！'
                                                                }
                                                            ]
                                                        }
                                                        getValue={this.formItemGetValue}
                                                    />

                                                    <div className={'from-mod pb24'}>
                                                        <div className={'from-mod-left'}>
                                                            <i className={'star'}>*</i>
                                                            <span>证明材料</span>
                                                        </div>
                                                        <div className={'from-mod-right pr'}>
                                                            <Upload
                                                                fileId={'feui-certGov'}
                                                                uploadType={'image-upload'}
                                                                noWarning={true}
                                                                name={'image'}
                                                                width={'96px'}
                                                                height={'96px'}
                                                                onHandleChange={data => {
                                                                    let file = data.value;

                                                                    if (file.type.substr(-3) !== 'png'
                                                                        && data.value.type.substr(-4) !== 'jpeg') {
                                                                        this.setState({
                                                                            certGovError: '图片格式不正确'
                                                                        });
                                                                        return false;
                                                                    }

                                                                    if (file.size > (1024 * 1024)) { // 1M
                                                                        this.setState({
                                                                            certGovError: '图片大小不符合要求'
                                                                        });
                                                                        return false;
                                                                    }

                                                                    file.formDatas.append('product_id', 'haoma');
                                                                    file.formDatas.append('is_spot', 'NO');

                                                                    let myInit = {
                                                                        method: 'POST',
                                                                        credentials: 'include',
                                                                        body: file.formDatas
                                                                    };

                                                                    fetch('/api/v1/image', myInit)
                                                                        .then(response => response.json())
                                                                        .then(response => {
                                                                            if (response.code === 200) {
                                                                                this.setState({
                                                                                    certGovId: response.data.id
                                                                                });
                                                                            } else {
                                                                                Toast.display({
                                                                                    type: 'error',
                                                                                    info: response.message,
                                                                                    delay: 3500
                                                                                });

                                                                            }
                                                                        });
                                                                }}
                                                            />
                                                            {certGovId
                                                                ? <div
                                                                    className={'load-mod'}
                                                                    style={{
                                                                        backgroundImage: `url(${
                                                                            urlStr + certGovId
                                                                        })`
                                                                    }}
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            magnifySrc: `${urlStr + certGovId}`,
                                                                            magnifyOff: true,
                                                                        });
                                                                    }}
                                                                >
                                                                    <div
                                                                        className={'close'}
                                                                        onClick={e => {
                                                                            this.setState({
                                                                                certGovId: false
                                                                            });
                                                                            e.stopPropagation();
                                                                        }}
                                                                    />
                                                                </div>
                                                                : null
                                                            }
                                                            {
                                                                certGovError
                                                                    ? <div className="spui2-form-warning">
                                                                        <i className="spui2-input-error"></i>
                                                                        <span>{certGovError}</span>
                                                                    </div>
                                                                    : null
                                                            }
                                                            <div
                                                                className={'shangbiao'}
                                                                onClick={() => {
                                                                    this.setState({
                                                                        magnifySrc: require(
                                                                            '../../asset/img/appeal/zf_1.jpg'
                                                                        ),
                                                                        magnifyOff: true,
                                                                    });
                                                                }}
                                                            >
                                                                <img
                                                                    src={require('../../asset/img/appeal/zf_1.jpg')}
                                                                    alt=""/>
                                                                <span>上传样例</span>
                                                                <i/>
                                                            </div>
                                                            <div
                                                                className={'shangbiao'}
                                                                style={{left: '264px'}}
                                                                onClick={() => {
                                                                    this.setState({
                                                                        magnifySrc: require(
                                                                            '../../asset/img/appeal/zf_2.png'
                                                                        ),
                                                                        magnifyOff: true,
                                                                    });
                                                                }}
                                                            >
                                                                <img
                                                                    src={require('../../asset/img/appeal/zf_2.png')}
                                                                    alt=""/>
                                                                <span>上传样例</span>
                                                                <i/>
                                                            </div>
                                                            <div
                                                                className={'shangbiao'}
                                                                style={{left: '488px'}}
                                                                onClick={() => {
                                                                    this.setState({
                                                                        magnifySrc: require(
                                                                            '../../asset/img/appeal/zf_3.png'
                                                                        ),
                                                                        magnifyOff: true,
                                                                    });
                                                                }}
                                                            >
                                                                <img
                                                                    src={require('../../asset/img/appeal/zf_3.png')}
                                                                    alt=""/>
                                                                <span>上传样例</span>
                                                                <i/>
                                                            </div>
                                                            <div
                                                                className={'icon-text'}
                                                                style={{width: '370px', left: '567px'}}
                                                            >
                                                                <div>
                                                                    <span>申诉号码的开户证明，缴费证明，网页截图等有效证明。任选其一</span><br/>
                                                                    <span>图片支持jpg或png格式，大小不超过1M</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <FormItem
                                                        type="textarea"
                                                        name={'otherReasonGov'}
                                                        width={'400px'}
                                                        spellCheck={false}
                                                        value={formData.otherReasonGov}
                                                        resize={false}
                                                        hidden={false}
                                                        label={<span>其他理由</span>}
                                                        countWay="character"
                                                        countComplete={true}
                                                        placeHolder={'请输入您要申诉的理由'}
                                                        getValue={this.formItemGetValue}
                                                    />

                                                    <FormItem
                                                        type="input"
                                                        value={formData.emailGov}
                                                        spellCheck={false}
                                                        name={'emailGov'}
                                                        horizontal={true}
                                                        label={<span><i className={'star'}>*</i>联系邮箱</span>}
                                                        placeHolder={'请输入正确的邮箱地址用来接收审核结果等'}
                                                        rules={
                                                            [
                                                                {
                                                                    validate(value) {
                                                                        let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                                        return v.length === 0;
                                                                    },
                                                                    message: '此项不能为空！'
                                                                },
                                                                {
                                                                    validate(value) {
                                                                        return !regEmail.test(value);
                                                                    },
                                                                    message: '联系邮箱格式不正确！'
                                                                }
                                                            ]
                                                        }
                                                        getValue={this.formItemGetValue}
                                                    />

                                                    <div>
                                                        <FormItem
                                                            type="input"
                                                            value={formData.captchaGov}
                                                            spellCheck={false}
                                                            name={'captchaGov'}
                                                            horizontal={true}
                                                            width={'120px'}
                                                            label={<span><i className={'star'}>*</i>邮箱验证码</span>}
                                                            placeHolder={'请输入验证码'}
                                                            tips={!codeOffGov
                                                                ? <span
                                                                    className={regEmail.test(formData.emailGov)
                                                                        ? 'link'
                                                                        : 'disable'}
                                                                    onClick={() => {
                                                                        if (regEmail.test(formData.emailGov)) {
                                                                            this.setState({
                                                                                codeOffGov: true
                                                                            }, () => {
                                                                                this.sendCodeFn(
                                                                                    'Gov',
                                                                                    'email', formData.emailGov
                                                                                );
                                                                            });
                                                                        }
                                                                    }}
                                                                >
                                                                    获取验证码
                                                                </span>
                                                                : <span className={'disable'}>
                                                                    {codeTimeGov}s后重新发送
                                                                </span>
                                                            }
                                                            rules={
                                                                [{
                                                                    validate(value) {
                                                                        let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                                        return v.length > 11;
                                                                    },
                                                                    message: '字符个数越界！'
                                                                }, {
                                                                    validate(value) {
                                                                        let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                                        return v.length === 0;
                                                                    },
                                                                    message: '此项不能为空！'
                                                                }
                                                                ]
                                                            }
                                                            getValue={this.formItemGetValue}
                                                        />
                                                    </div>


                                                </div>
                                                : null

                                            }

                                            {appealType === '2' && formData.radioType2 === '1'
                                                ? null
                                                : <div className={'form-check'}>
                                                    {/* <Checkbox
                                                        name="zzz"
                                                        value="rrr"
                                                        theme={'blue'}
                                                        checked={this.state.checkboxValue1}
                                                        getValue={e => {
                                                            this.setState({
                                                                checkboxValue1: e.checked
                                                            });
                                                        }}
                                                    >
                                                        <span>开启多平台展示 | 百度号码认证平台帮您同步标记至其他平台</span>
                                                        <span className={'c4'}>【推荐】</span>
                                                    </Checkbox> */}

                                                    <Checkbox
                                                        name="zzz"
                                                        value="rrr"
                                                        theme={'blue'}
                                                        checked={checkboxValue2}
                                                        getValue={e => {
                                                            this.setState({
                                                                checkboxValue2: e.checked
                                                            });
                                                        }}
                                                    >
                                                        <span>已阅读</span>
                                                        <a
                                                            href="https://haoma.baidu.com/privacy/agreement.html"
                                                            className={'link line'}
                                                            rel="noopener noreferrer"
                                                            target={'_blank'}>《企业号码认证服务协议》</a>
                                                        <span>和</span>
                                                        <a
                                                            href="https://haoma.baidu.com/privacy/index.html"
                                                            className={'link line'}
                                                            rel="noopener noreferrer"
                                                            target={'_blank'}>《百度号码服务隐私政策》</a>
                                                    </Checkbox>
                                                </div>

                                            }

                                            <div className={'form-btn'}>
                                                <div>
                                                    <FormItem
                                                        name={'f12'}
                                                        className={'spui2-m-r10'}
                                                        styleType={'ghost'}
                                                        label={'取消修改'}
                                                        type="button"
                                                        onClick={() => {
                                                            this.setState({promptOff: true}, () => {
                                                                this.props.history.push(`/info_appeal/${id}`);
                                                            });
                                                        }}
                                                    />

                                                    <FormItem
                                                        name={'f11'}
                                                        styleType={'modal'}
                                                        disabled={!checkboxValue2}
                                                        label={'提交修改'}
                                                        submitFlag={true}
                                                        type="button"
                                                    />
                                                </div>

                                                {
                                                    appealType === '2' && formData.radioType2 === '1'
                                                        ? null
                                                        : <div className={'text'}>
                                                            申请提交后，会在2个工作日内审核完毕
                                                        </div>
                                                }

                                            </div>
                                        </Form>
                                    </div>
                                </div>
                                : <div className={'info-from'}>
                                    <div className={'mod-title'}>
                                        申诉信息
                                    </div>

                                    {
                                        pageObj.mode === 2
                                            ? <div className={'mt20'}>
                                                <div className={'mod-label'}>
                                                    <div className={'left'}>
                                                        <i className={'star'}>*</i><span>申诉号码</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        {pageObj.phone}
                                                    </div>
                                                </div>
                                                <div className={'mod-label'}>
                                                    <div className={'left'}>
                                                        <i className={'star'}>*</i><span>申诉类型</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        个人号码申诉
                                                    </div>
                                                </div>
                                                <div className={'mod-label'}>
                                                    <div className={'left'}>
                                                        <i className={'star'}>*</i><span>号码类型</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        {pageObj.type === 2 ? '手机号码' : '座机号码'}
                                                    </div>
                                                </div>
                                                <div className={'mod-label'}>
                                                    <div className={'left'}>
                                                        <i className={'star'}>*</i><span>申诉理由</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        {'号码被错误标记/占用'}
                                                    </div>
                                                </div>
                                                <div className={'mod-label'}>
                                                    <div className={'left'}>
                                                        <span>其他理由</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        {
                                                            pageObj.reason || '-'
                                                        }
                                                    </div>
                                                </div>

                                                {pageObj.type === 1
                                                    ? <div className={'mod-label'}>
                                                        <div className={'left'}>
                                                            <i className={'star'}>*</i><span>联系邮箱</span>
                                                        </div>
                                                        <div className={'right'}>
                                                            {pageObj.email ? pageObj.email : '-'}
                                                        </div>
                                                    </div>
                                                    : null
                                                }


                                                {pageObj.cert_other_1 && pageObj.type === 1
                                                    ? <div className={'mod-img mt24'}>
                                                        <div>
                                                            <div
                                                                className={'img'}
                                                                style={{
                                                                    backgroundImage: `url(${
                                                                        urlStr + pageObj.cert_other_1})`
                                                                }}
                                                            />
                                                            <div className={'text'}>
                                                                <i className={'star'}>*</i><span>证明材料</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : null
                                                }


                                            </div>
                                            : null
                                    }

                                    {
                                        pageObj.mode === 4
                                            ? <div>
                                                <div className={'mt20 label146'}>
                                                    <div className={'mod-label'}>
                                                        <div className={'left'}>
                                                            <i className={'star'}>*</i><span>申诉号码</span>
                                                        </div>
                                                        <div className={'right'}>
                                                            23232343
                                                        </div>
                                                    </div>
                                                    <div className={'mod-label'}>
                                                        <div className={'left'}>
                                                            <i className={'star'}>*</i><span>申诉类型</span>
                                                        </div>
                                                        <div className={'right'}>
                                                            个人号码申诉
                                                        </div>
                                                    </div>
                                                    <div className={'mod-label'}>
                                                        <div className={'left'}>
                                                            <i className={'star'}>*</i><span>申诉理由</span>
                                                        </div>
                                                        <div className={'right'}>
                                                            申诉理由
                                                        </div>
                                                    </div>
                                                    <div className={'mod-label'}>
                                                        <div className={'left'}>
                                                            <i className={'star'}>*</i><span>更正标记</span>
                                                        </div>
                                                        <div className={'right'}>
                                                            更正标记
                                                        </div>
                                                    </div>

                                                    <div className={'mod-label mt24'}>
                                                        <div className={'left'}>
                                                            <i className={'opacity'}>*</i><span>展示名称</span>
                                                        </div>
                                                        <div className={'right'}>
                                                            展示名称
                                                        </div>
                                                    </div>
                                                    <div className={'mod-label'}>
                                                        <div className={'left'}>
                                                            <i className={'star'}>*</i><span>认证号码</span>
                                                        </div>
                                                        <div className={'right'}>
                                                            认证号码<br/>
                                                            认证号码
                                                        </div>
                                                    </div>

                                                    <div className={'mod-label mt24'}>
                                                        <div className={'left'}>
                                                            <i className={'opacity'}>*</i><span>企业网站首页地址</span>
                                                        </div>
                                                        <div className={'right'}>
                                                            企业网站首页地址
                                                        </div>
                                                    </div>
                                                    <div className={'mod-label'}>
                                                        <div className={'left'}>
                                                            <i className={'star'}>*</i><span>网站备案许可证号</span>
                                                        </div>
                                                        <div className={'right'}>
                                                            网站备案许可证号
                                                        </div>
                                                    </div>

                                                    <div className={'mod-label mt24'}>
                                                        <div className={'left'}>
                                                            <i className={'opacity'}>*</i><span>商标注册证号</span>
                                                        </div>
                                                        <div className={'right'}>
                                                            商标注册证号
                                                        </div>
                                                    </div>
                                                    <div className={'mod-label'}>
                                                        <div className={'left'}>
                                                            <i className={'opacity'}>*</i><span>商标注册证有效日期</span>
                                                        </div>
                                                        <div className={'right'}>
                                                            商标注册证有效日期
                                                        </div>
                                                    </div>
                                                    <div className={'mod-label'}>
                                                        <div className={'left'}>
                                                            <i className={'opacity'}>*</i><span>商标注册单位名称</span>
                                                        </div>
                                                        <div className={'right'}>
                                                            商标注册单位名称
                                                        </div>
                                                    </div>

                                                    <div className={'mod-img mt24'}>
                                                        <div>
                                                            <div className={'img'}/>
                                                            <div className={'text'}>
                                                                <i className={'star'}>*</i><span>icp备案</span>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className={'img'}/>
                                                            <div className={'text'}>
                                                                <i className={'star'}>*</i><span>企业Logo</span>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className={'img'}/>
                                                            <div className={'text'}>
                                                                <i className={'star'}>*</i><span>商标注册证</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className={'mod-title mt20'}>
                                                    认证资质
                                                </div>

                                                <div className={'mt20 label146'}>
                                                    <div className={'mod-label'}>
                                                        <div className={'left'}>
                                                            <i className={'star'}>*</i><span>申诉号码</span>
                                                        </div>
                                                        <div className={'right'}>
                                                            23232343
                                                        </div>
                                                    </div>
                                                    <div className={'mod-label'}>
                                                        <div className={'left'}>
                                                            <i className={'star'}>*</i><span>企业名称</span>
                                                        </div>
                                                        <div className={'right'}>
                                                            企业名称
                                                        </div>
                                                    </div>
                                                    <div className={'mod-label'}>
                                                        <div className={'left'}>
                                                            <i className={'star'}>*</i><span>企业地址</span>
                                                        </div>
                                                        <div className={'right'}>
                                                            河北省/石家庄市<br/>
                                                            XX区XX街道XX楼XX号
                                                        </div>
                                                    </div>
                                                    <div className={'mod-label'}>
                                                        <div className={'left'}>
                                                            <i className={'star'}>*</i><span>行业类型</span>
                                                        </div>
                                                        <div className={'right'}>
                                                            行业类型
                                                        </div>
                                                    </div>
                                                    <div className={'mod-label mt24'}>
                                                        <div className={'left'}>
                                                            <i className={'opacity'}>*</i><span>联系邮箱</span>
                                                        </div>
                                                        <div className={'right'}>
                                                            {pageObj.email ? pageObj.email : '-'}
                                                        </div>
                                                    </div>

                                                    <div className={'mod-img mt24'}>
                                                        <div>
                                                            <div className={'img'}/>
                                                            <div className={'text'}>
                                                                <i className={'star'}>*</i><span>企业合法资质</span>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className={'img'}/>
                                                            <div className={'text'}>
                                                                <i className={'star'}>*</i><span>运营商证明</span>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className={'img'}/>
                                                            <div className={'text'}>
                                                                <i className={'star'}>*</i><span>其他证明</span>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className={'img'}/>
                                                            <div className={'text'}>
                                                                <i className={'star'}>*</i><span>企业Logo</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            : null
                                    }

                                    {
                                        pageObj.mode === 1
                                            ? <div className={'mt20'}>
                                                <div className={'mod-label'}>
                                                    <div className={'left'}>
                                                        <i className={'star'}>*</i><span>申诉号码</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        {pageObj.phone}
                                                    </div>
                                                </div>
                                                <div className={'mod-label'}>
                                                    <div className={'left'}>
                                                        <i className={'star'}>*</i><span>申诉类型</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        企业号码申诉
                                                    </div>
                                                </div>
                                                <div className={'mod-label'}>
                                                    <div className={'left'}>
                                                        <i className={'star'}>*</i><span>申诉理由</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        {['', '号码被错误标记/占用', '不希望显示企业号码', '企业与号码信息有误'][+pageObj.label]}
                                                    </div>
                                                </div>

                                                <div className={'mod-label mt24'}>
                                                    <div className={'left'}>
                                                        <i className={'star'}>*</i><span>企业名称</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        {pageObj.name ? pageObj.name : '-'}
                                                    </div>
                                                </div>
                                                <div className={'mod-label'}>
                                                    <div className={'left'}>
                                                        <i className={'star'}>*</i><span>企业地址</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        {pageObj.company_province && pageObj.company_city
                                                            ? `${pageObj.company_province}/`
                                                            : (pageObj.company_province && !pageObj.company_city
                                                                ? `${pageObj.company_province}` : '')}
                                                        {pageObj.company_city ? pageObj.company_city
                                                            : (pageObj.company_province ? '' : '-') }<br/>
                                                        {pageObj.company_addr ? pageObj.company_addr : ''}
                                                    </div>
                                                </div>
                                                <div className={'mod-label'}>
                                                    <div className={'left'}>
                                                        <i className={'star'}>*</i><span>行业类型</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        {pageObj.industry ? pageObj.industry : '-'}
                                                    </div>
                                                </div>
                                                <div className={'mod-label mt24'}>
                                                    <div className={'left'}>
                                                        <i className={'opacity'}>*</i><span>联系邮箱</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        {pageObj.email ? pageObj.email : '-'}
                                                    </div>
                                                </div>


                                                <div className={'mod-img mt24'}>
                                                    {pageObj.company_qualify_id
                                                        ? <div>
                                                            <div
                                                                className={'img'}
                                                                style={{
                                                                    backgroundImage: `url(${
                                                                        urlStr + pageObj.company_qualify_id
                                                                    })`
                                                                }}
                                                            />
                                                            <div className={'text'}>
                                                                <i className={'star'}>*</i><span>企业合法资质</span>
                                                            </div>
                                                        </div>
                                                        : null
                                                    }
                                                    {pageObj.company_operator_id
                                                        ? <div>
                                                            <div
                                                                className={'img'}
                                                                style={{
                                                                    backgroundImage: `url(${
                                                                        urlStr + pageObj.company_operator_id
                                                                    })`
                                                                }}
                                                            />
                                                            <div className={'text'}>
                                                                <i className={'star'}>*</i><span>运营商证明</span>
                                                            </div>
                                                        </div>
                                                        : null
                                                    }
                                                    {pageObj.cert_other_1
                                                        ? <div>
                                                            <div
                                                                className={'img'}
                                                                style={{
                                                                    backgroundImage: `url(${
                                                                        urlStr + pageObj.cert_other_1
                                                                    })`
                                                                }}
                                                            />
                                                            <div className={'text'}>
                                                                <i className={'star'}>*</i><span>其他证明</span>
                                                            </div>
                                                        </div>
                                                        : null
                                                    }
                                                </div>
                                            </div>
                                            : null

                                    }

                                    {
                                        pageObj.mode === 3
                                            ? <div className={'mt20'}>
                                                <div className={'mod-label'}>
                                                    <div className={'left'}>
                                                        <i className={'star'}>*</i><span>申诉号码</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        {pageObj.phone}
                                                    </div>
                                                </div>

                                                <div className={'mod-label'}>
                                                    <div className={'left'}>
                                                        <i className={'star'}>*</i><span>申诉类型</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        政府号码申诉
                                                    </div>
                                                </div>
                                                <div className={'mod-label'}>
                                                    <div className={'left'}>
                                                        <i className={'star'}>*</i><span>申诉理由</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        {['', '号码被错误标记/占用', '不希望显示政府号码', '政府与号码信息有误'][+pageObj.label]}
                                                    </div>
                                                </div>

                                                <div className={'mod-label mt24'}>
                                                    <div className={'left'}>
                                                        <i className={'star'}>*</i><span>政府名称</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        {pageObj.name}
                                                    </div>
                                                </div>
                                                <div className={'mod-label'}>
                                                    <div className={'left'}>
                                                        <span>其他理由</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        {pageObj.reason}
                                                    </div>
                                                </div>

                                                <div className={'mod-label mt24'}>
                                                    <div className={'left'}>
                                                        <i className={'opacity'}>*</i><span>联系邮箱</span>
                                                    </div>
                                                    <div className={'right'}>
                                                        {pageObj.email ? pageObj.email : '-'}
                                                    </div>
                                                </div>

                                                <div className={'mod-img mt24'}>
                                                    {pageObj.cert_other_1
                                                        ? <div>
                                                            <div
                                                                className={'img'}
                                                                style={{
                                                                    backgroundImage: `url(${
                                                                        urlStr + pageObj.cert_other_1
                                                                    })`
                                                                }}
                                                            />
                                                            <div className={'text'}>
                                                                <i className={'star'}>*</i><span>证明材料</span>
                                                            </div>
                                                        </div>
                                                        : null
                                                    }
                                                </div>
                                            </div>
                                            : null
                                    }


                                    {/* <div className={'mod-img mt24'}>
                                        <Checkbox
                                            name="zzz1"
                                            value="rrr1"
                                            theme={'blue'}
                                            disabled={true}
                                            checked={pageObj.is_show}
                                            getValue={e => {
                                                this.setState({
                                                    checkboxValue1: e.checked
                                                });
                                            }}
                                        >
                                            <span>开启多平台展示 | 百度号码认证平台通您同步标记至其他平台</span>
                                        </Checkbox>
                                    </div> */}

                                    {/* <div className={'typ1-btn'}>
                                        <Button {...btnProps} />
                                    </div> */}
                                </div>

                        }
                    </div>
                    : null
                }

                {
                    magnifyOff
                        ? <div
                            className={'magnify'}
                            onClick={() => {
                                this.setState({magnifyOff: false});
                            }}
                        >
                            <img
                                src={magnifySrc}
                                alt=""
                                onClick={e => {
                                    e.stopPropagation();
                                }}
                            />
                        </div>
                        : null
                }
            </div>
        );
    }
}

InfoAppeal.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    fetchGetDetail: PropTypes.func,
    fetchSendCode: PropTypes.func,
    fetchGetDetai: PropTypes.func,
    fetchGetEdit: PropTypes.func
};

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        fetchSendCode: obj => fetchSendCode(dispatch, obj),
        fetchGetEdit: obj => fetchGetEdit(dispatch, obj),
        fetchGetDetail: obj => fetchGetDetail(dispatch, obj)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InfoAppeal));